import { makeStyles } from "@material-ui/core";
import { Colors } from '../../../styles/Colors';

export const useStyles = makeStyles(() => ({
    productNameContainer: {
        padding: '8px 22px',
        minHeight: 37,
        height: 'fit-content',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    productName: {
        fontWeight: 700,
        fontSize: 16,
        lineHeight: '16px',
        verticalAlign: 'middle',
        color: Colors.Text,
        paddingTop: 8,
        maxWidth: 340,
    },
    mainProduct: {
        color: 'rgba(76, 134, 183, 1)',
        width: 'fit-content',
        height: 16,
        borderRadius: 2,
        border: '1px solid rgba(76, 134, 183, 1)',
        padding: '4px 8px',
        fontWeight: 400,
        fontSize: 10,
        lineHeight: '16px',
        verticalAlign: 'middle',
        textTransform: 'uppercase',
        overflow: 'hidden',
        whiteSpace: 'nowrap',
    },
    counterContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '8px 24px',
        width: 'calc(100% - 48px)'
    },
    productsSectionMainContainer: {
        display: 'flex',
        flexDirection: 'column',
        padding: '10px 8px',
        position: 'relative'
    },
    productsSectionFirstLine: {
        color: Colors.Text,
        fontWeight: 400,
        fontSize: 14,
        lineHeight: '18px',
        width: 'calc(100% + 17px)',
        paddingRight: 0,
    },
    productsSectionSecondLine: {
        width: '100%',
        color: Colors.Gray9,
        fontWeight: 400,
        fontSize: 12,
        lineHeight: '14px',
    },
    productsSectionLinearProgress: {
        maxWidth: 'unset',
        width: '100%'
    },
    productsSectionLinearProgressContainer: {
        maxWidth: 'unset',
        width: 'calc(100% + 17px)',
        marginTop: 4,
        paddingRight: 0,
    },
    productsSectionValuesContainer: {
        display: 'flex',
        flexDirection: 'row',
        gap: 6,
        justifyContent: 'flex-start',
        width: '100%',
        fontSize: 14,
        lineHeight: '24px',
        marginTop: 4,
    },
    productsSectionUsedQuantity: {
        color: Colors.Text,
        fontWeight: 500,
    },
    productsSectionMaxQuantity: {
        color: Colors.Gray9,
        fontWeight: 400,
    },
    productsSectionThirdColumn: {
        position: 'absolute',
        top: 10,
        right: 0,
    },
    productsSectionMainProductLabel: {
        fontWeight: 400,
        fontSize: 10,
        lineHeight: '14px',
        verticalAlign: 'middle',
        textTransform: 'uppercase',
        padding: '2px 4px'
    },
    customWidgetContainerClass: {
        marginBottom: 24,
    },
    customWidgetContentClass: {
        maxHeight: 'unset'
    },
    sharedProduct: {
        color: 'rgb(245, 132, 31)',
        border: '1px solid rgb(245, 132, 31)',
    }
}));